module.exports = __webpack_public_path__ + "img/gb9115_25_c.prt.941f5080.jpg";